import React, { useEffect, useState, useCallback, useRef } from "react";
import { Link } from "react-router";
import { Button, Modal, Toast, Select } from "../ui";
import DetailInscricao from "./DetailInscricao";
import InscricaoService from "../../services/Inscricoes/InscricaoService";
import NovaMetricaCorredor from "./NovaMetricaCorredor";
import StravaBadge from "../strava/StravaBadge";
import StravaImportModal from "../strava/StravaImportModal";
import { StravaIcon } from "../strava/StravaConnectButton";
import { initMercadoPago } from "@mercadopago/sdk-react";
import { MERCADOPAGO_PUBLIC_KEY } from "../../services/config";
import CheckoutPage from "../checkout/CheckoutPage";
import { formatDateBR } from "../../utils/dateUtils";
import {
  CheckCircle2,
  Flag,
  Clock,
  MapPin,
  Calendar,
  Navigation,
  Eye,
  BarChart2,
  ChevronRight,
  AlertTriangle,
  ArrowRight,
  CreditCard,
  Map,
  User,
  Users,
} from "lucide-react";

const inscricaoService = new InscricaoService();

initMercadoPago(MERCADOPAGO_PUBLIC_KEY);

function MinhasCorridasComponent({ counts }) {
  const toast = useRef(null);
  const [visible, setVisible] = useState(false);
  const [visibleDialogMetrica, setVisibleDialogMetrica] = useState(false);
  const [visibleDialogPagamento, setVisibleDialogPagamento] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [metrica, setMetrica] = useState(null);
  const [metricaLoading, setMetricaLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [searchQuery] = useState("");
  const [sortOrder, setSortOrder] = useState("recentes");
  const [paymentError, setPaymentError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const handlePaymentError = (err) => {
    const status = err?.status || err?.response?.status || err?.statusCode;
    const msg =
      err?.message ||
      err?.detail ||
      err?.erro ||
      err?.data?.detail ||
      err?.data?.message ||
      err?.data?.erro ||
      (typeof err === "string" ? err : "Erro no processamento do pagamento.");

    if (status === 400 || !status || err?.status === 400) {
      setPaymentError(msg);
    }
  };

  const [activeRaces, setActiveRaces] = useState([]);
  const [finishedRaces, setFinishedRaces] = useState([]);
  const [pendingRaces, setPendingRaces] = useState([]);
  const [showStravaModal, setShowStravaModal] = useState(false);

  const userId = sessionStorage.getItem("brv-user-id");
  const userName = sessionStorage.getItem("brv-user") || "Atleta";

  const handleMetricaSuccess = async () => {
    if (toast.current) {
      toast.current.show({
        severity: "success",
        summary: "Métricas Registradas!",
        detail: "Suas métricas da corrida foram salvas com sucesso.",
        life: 4000,
      });
    }
    if (selectedProduct) {
      await handleMetricaCorredor(
        selectedProduct.id_corrida || selectedProduct.id
      );
    }
  };

  const handleMetricaError = () => {
    if (toast.current) {
      toast.current.show({
        severity: "error",
        summary: "Erro",
        detail: "Não foi possível registrar as métricas. Tente novamente.",
        life: 4000,
      });
    }
  };

  const fetchData = useCallback(
    async (index) => {
      try {
        let response;
        switch (index) {
          case 0:
            response = await inscricaoService.getCorridasAtuaisUsuario(userId);
            if (response && response.ok) {
              const data = await response.json();
              if (Array.isArray(data)) {
                setActiveRaces(
                  data.filter((r) => r.status !== "Aguardando Pagamento")
                );
              } else {
                setActiveRaces([]);
              }
            }
            break;
          case 1:
            try {
              response = await inscricaoService.getCorridasFinalizadasUsuario(
                userId
              );
              if (response && response.ok) {
                const data = await response.json();
                setFinishedRaces(Array.isArray(data) ? data : []);
              } else {
                const resAll =
                  await inscricaoService.getInscricaoPerUsuario(userId);
                if (resAll && resAll.ok) {
                  const dataAll = await resAll.json();
                  if (Array.isArray(dataAll)) {
                    setFinishedRaces(
                      dataAll.filter((r) => {
                        const status = (r.status || "").toLowerCase();
                        const statusEvento = (
                          r.status_evento || ""
                        ).toLowerCase();
                        return (
                          status.includes("finaliz") ||
                          status.includes("encerr") ||
                          status.includes("conclu") ||
                          statusEvento.includes("finaliz") ||
                          statusEvento.includes("encerr") ||
                          statusEvento.includes("conclu")
                        );
                      })
                    );
                  }
                }
              }
            } catch (err) {
              console.error("Erro ao buscar finalizadas:", err);
            }
            break;
          case 2:
            try {
              response = await inscricaoService.getCorridasPendentesUsuario(
                userId
              );
              if (response && response.ok) {
                const data = await response.json();
                setPendingRaces(Array.isArray(data) ? data : []);
              } else {
                const resAbertas =
                  await inscricaoService.getCorridasAtuaisUsuario(userId);
                if (resAbertas && resAbertas.ok) {
                  const dataAbertas = await resAbertas.json();
                  setPendingRaces(
                    Array.isArray(dataAbertas)
                      ? dataAbertas.filter(
                          (r) => r.status === "Aguardando Pagamento"
                        )
                      : []
                  );
                }
              }
            } catch (err) {
              console.error("Erro ao buscar pendentes:", err);
            }
            break;
          default:
            break;
        }
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    },
    [userId]
  );

  useEffect(() => {
    fetchData(0);
    fetchData(1);
    fetchData(2);
  }, [fetchData]);

  async function handleMetricaCorredor(id_corrida) {
    setVisibleDialogMetrica(true);
    setMetricaLoading(true);
    setMetrica(null);

    try {
      const res = await inscricaoService.getMetricaCorredoro(
        id_corrida,
        sessionStorage.getItem("brv-user-id")
      );
      const data = await res.json();
      setMetrica(data);
      return data;
    } catch (err) {
      console.log(err);
      setMetrica(null);
      return null;
    } finally {
      setMetricaLoading(false);
    }
  }

  const normalizeMetrica = (data) => {
    if (!data || data.detail) {
      return [];
    }
    return Array.isArray(data) ? data : [data];
  };

  const renderMetrica = () => {
    const items = normalizeMetrica(metrica);
    if (!items.length) return null;

    return (
      <div className="flex flex-col gap-3">
        {items.map((item, index) => {
          const isStrava = Boolean(
            item.origem === "strava" ||
              item.is_strava ||
              item.strava_activity_id ||
              item.strava
          );

          return (
            <div
              key={item.id || index}
              className="rounded-xl border border-slate-800 bg-slate-950/70 p-4 text-left grid grid-cols-2 gap-2 text-xs relative"
            >
              {isStrava && (
                <div className="col-span-2 flex justify-end pb-1 mb-1 border-b border-slate-800/80">
                  <StravaBadge />
                </div>
              )}
              <div>
                <strong className="text-slate-400">Posição Geral:</strong>{" "}
                <span className="text-white font-bold">{item.posicao_geral ?? "-"}</span>
              </div>
              <div>
                <strong className="text-slate-400">Posição Categoria:</strong>{" "}
                <span className="text-white font-bold">{item.posicao_categoria ?? "-"}</span>
              </div>
              <div>
                <strong className="text-slate-400">Tempo Oficial:</strong>{" "}
                <span className="text-urb-primary font-bold">{item.tempo_oficial ?? "-"}</span>
              </div>
              <div>
                <strong className="text-slate-400">Tempo Bruto:</strong>{" "}
                <span className="text-white">{item.tempo_bruto ?? "-"}</span>
              </div>
              <div>
                <strong className="text-slate-400">Ritmo:</strong>{" "}
                <span className="text-white">{item.ritmo ?? "-"}</span>
              </div>
              <div>
                <strong className="text-slate-400">KM/H:</strong>{" "}
                <span className="text-white">{item.kmh ?? "-"}</span>
              </div>
              <div className="col-span-2">
                <strong className="text-slate-400">Hora Partida:</strong>{" "}
                <span className="text-white">{item.hora_partida ?? "-"}</span>
              </div>
            </div>
          );
        })}

        <div className="pt-2 flex justify-end">
          <button
            type="button"
            onClick={() => setShowStravaModal(true)}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-[#FC4C02]/15 text-[#FC4C02] hover:bg-[#FC4C02]/25 border border-[#FC4C02]/30 text-xs font-bold transition-all cursor-pointer"
          >
            <StravaIcon className="w-3.5 h-3.5" />
            <span>Atualizar dados via Strava</span>
          </button>
        </div>
      </div>
    );
  };

  const metricaContent = renderMetrica();

  const getTabRaces = () => {
    switch (activeIndex) {
      case 0:
        return activeRaces;
      case 1:
        return finishedRaces;
      case 2:
        return pendingRaces;
      default:
        return [];
    }
  };

  const tabRaces = getTabRaces();
  let filteredRaces = Array.isArray(tabRaces)
    ? tabRaces.filter((race) => {
        if (!searchQuery) return true;
        return (
          (race.nome_corrida || "")
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          (race.cidade_evento || "")
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
        );
      })
    : [];

  if (sortOrder === "antigas") {
    filteredRaces = [...filteredRaces].reverse();
  }

  const totalPages = Math.ceil(filteredRaces.length / itemsPerPage);
  const paginatedRaces = filteredRaces.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const activeCount = Array.isArray(activeRaces)
    ? activeRaces.length
    : counts?.qtd_corrida || 0;
  const pendingCount = Array.isArray(pendingRaces) ? pendingRaces.length : 0;
  const finishedCount = Array.isArray(finishedRaces) ? finishedRaces.length : 0;
  const kmCount = counts?.km_corridos || 0;

  return (
    <div className="w-full text-left">
      <Toast ref={toast} />

      {/* Top Dashboard Summary Header Card */}
      <div className="w-full rounded-3xl border border-urb-border p-6 md:p-8 mb-8 bg-urb-card/90 shadow-2xl relative overflow-hidden flex flex-col lg:flex-row items-center justify-between gap-6">
        {/* Left Greeting */}
        <div className="text-left flex flex-col gap-1 w-full lg:w-auto">
          <div className="flex items-center gap-2.5">
            <div className="w-1.5 h-7 rounded-full bg-urb-primary" />
            <h1 className="text-2xl md:text-3xl font-black text-white m-0 tracking-tight">
              Olá, {userName}
            </h1>
          </div>
          <p className="text-xs md:text-sm text-slate-400 m-0 mt-1 max-w-sm leading-relaxed">
            Acompanhe suas inscrições, pagamentos e histórico de provas.
          </p>
        </div>

        {/* Right 4 Summary Metric Cards */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 w-full lg:w-auto">
          {/* Card 1: Corridas ativas */}
          <div className="p-3.5 rounded-2xl border border-slate-800 bg-slate-950/70 flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-urb-primary/10 text-urb-primary border border-urb-primary/30 shrink-0">
              <Navigation className="w-5 h-5" />
            </div>
            <div className="flex flex-col text-left">
              <span className="text-[10px] text-slate-400 font-semibold uppercase tracking-wider">
                Ativas
              </span>
              <span className="text-xl font-black text-white">{activeCount}</span>
            </div>
          </div>

          {/* Card 2: Pagamentos pendentes */}
          <div className="p-3.5 rounded-2xl border border-slate-800 bg-slate-950/70 flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-amber-500/10 text-amber-400 border border-amber-500/30 shrink-0">
              <CreditCard className="w-5 h-5" />
            </div>
            <div className="flex flex-col text-left">
              <span className="text-[10px] text-slate-400 font-semibold uppercase tracking-wider">
                Pendentes
              </span>
              <span className="text-xl font-black text-amber-400">{pendingCount}</span>
            </div>
          </div>

          {/* Card 3: Corridas concluídas */}
          <div className="p-3.5 rounded-2xl border border-slate-800 bg-slate-950/70 flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-urb-primary/10 text-urb-primary border border-urb-primary/30 shrink-0">
              <CheckCircle2 className="w-5 h-5" />
            </div>
            <div className="flex flex-col text-left">
              <span className="text-[10px] text-slate-400 font-semibold uppercase tracking-wider">
                Concluídas
              </span>
              <span className="text-xl font-black text-white">{finishedCount}</span>
            </div>
          </div>

          {/* Card 4: Km percorridos */}
          <div className="p-3.5 rounded-2xl border border-slate-800 bg-slate-950/70 flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-urb-primary/10 text-urb-primary border border-urb-primary/30 shrink-0">
              <Map className="w-5 h-5" />
            </div>
            <div className="flex flex-col text-left">
              <span className="text-[10px] text-slate-400 font-semibold uppercase tracking-wider">
                Km corridos
              </span>
              <span className="text-xl font-black text-white">{kmCount} km</span>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Tabs and Sort Dropdown */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6 gap-4 border-b border-urb-border pb-4">
        {/* Tabs */}
        <div className="flex items-center gap-2">
          {[
            { label: "Ativas", index: 0 },
            { label: "Encerradas", index: 1 },
            { label: "Pendentes", index: 2 },
          ].map((tab) => (
            <button
              key={tab.index}
              type="button"
              onClick={() => {
                setActiveIndex(tab.index);
                setCurrentPage(1);
                fetchData(tab.index);
              }}
              className={`py-2 px-4 rounded-xl text-xs font-bold transition-all cursor-pointer border ${
                activeIndex === tab.index
                  ? "bg-urb-primary text-black border-urb-primary shadow-lg"
                  : "bg-slate-900 border-slate-800 text-slate-400 hover:text-white"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Sort Select */}
        <div className="w-full sm:w-48">
          <Select
            value={sortOrder}
            options={[
              { label: "Mais recentes", value: "recentes" },
              { label: "Mais antigas", value: "antigas" },
            ]}
            onChange={(e) => setSortOrder(e.target.value)}
          />
        </div>
      </div>

      {/* Races List */}
      <div className="flex flex-col gap-4">
        {paginatedRaces.length === 0 ? (
          <div className="p-12 text-center rounded-2xl border border-slate-800 bg-slate-950/40 text-slate-400 text-sm">
            Nenhuma inscrição encontrada nesta categoria.
          </div>
        ) : (
          paginatedRaces.map((product) => {
            const isPending = product.status === "Aguardando Pagamento";
            const isFinished =
              activeIndex === 1 ||
              product.status === "Encerrada" ||
              product.status === "Finalizada" ||
              product.status === "Concluída";

            const nomeAtleta = product.nome_corredor || [product.first_name, product.last_name].filter(Boolean).join(" ");
            const isTerceiro = Boolean(product.is_terceiro);

            // Verifica se faz parte de um lote pendente com mais itens
            const grupoPendente = (isPending && product.id_grupo_pagamento)
              ? pendingRaces.filter(r => r.id_grupo_pagamento === product.id_grupo_pagamento)
              : [];
            const isLotePendente = grupoPendente.length > 1;
            const valorTotalLote = isLotePendente
              ? grupoPendente.reduce((acc, curr) => acc + Number(curr.valor_pagamento || 0), 0)
              : Number(product.valor_pagamento || product.valor_inscricao || 0);

            return (
              <div
                key={product.id}
                className="rounded-2xl border border-urb-border p-5 bg-urb-card/80 hover:border-slate-700 transition-all shadow-xl flex flex-col lg:flex-row items-stretch justify-between gap-6"
              >
                {/* Left Column: Image Poster */}
                <div className="w-full lg:w-48 h-36 rounded-xl overflow-hidden border border-slate-800 shrink-0 bg-slate-950">
                  <img
                    src={
                      product.folder ||
                      "https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?auto=format&fit=crop&w=600&q=80"
                    }
                    alt={product.nome_corrida}
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Center Column: Race Info */}
                <div className="flex-1 flex flex-col justify-between text-left gap-3 min-w-0">
                  <div>
                    <div className="flex items-center gap-2 flex-wrap mb-1">
                      <h3 className="text-lg sm:text-xl font-black text-white uppercase m-0 tracking-tight truncate">
                        {product.nome_corrida}
                      </h3>
                      {isTerceiro ? (
                        <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-bold bg-blue-500/15 text-blue-400 border border-blue-500/30">
                          <Users className="w-3 h-3" />
                          Terceiro
                        </span>
                      ) : (
                        <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-bold bg-slate-800 text-slate-300 border border-slate-700">
                          <User className="w-3 h-3" />
                          Titular
                        </span>
                      )}
                    </div>

                    {/* Nome do Corredor */}
                    {nomeAtleta && (
                      <p className="text-xs font-semibold text-slate-300 m-0">
                        Atleta: <span className="text-white font-bold">{nomeAtleta}</span>
                      </p>
                    )}

                    {/* Status Badge */}
                    <div
                      className={`mt-2 inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold ${
                        isPending
                          ? "bg-amber-500/10 text-amber-400 border border-amber-500/30"
                          : isFinished
                          ? "bg-slate-800 text-slate-400 border border-slate-700"
                          : "bg-urb-primary/10 text-urb-primary border border-urb-primary/30"
                      }`}
                    >
                      {isPending ? (
                        <Clock className="w-3.5 h-3.5" />
                      ) : isFinished ? (
                        <Flag className="w-3.5 h-3.5" />
                      ) : (
                        <CheckCircle2 className="w-3.5 h-3.5" />
                      )}
                      <span>
                        {product.status ||
                          (isFinished ? "Concluída" : "Inscrito")}
                      </span>
                    </div>

                    {isLotePendente && (
                      <span className="block mt-1 text-[11px] font-semibold text-amber-400">
                        Pedido em lote com {grupoPendente.length} inscrições (Total: R$ {valorTotalLote.toLocaleString("pt-BR", { minimumFractionDigits: 2 })})
                      </span>
                    )}
                  </div>

                  {/* Info Row */}
                  <div className="flex flex-wrap items-center gap-4 text-xs text-slate-400">
                    <span className="flex items-center gap-1.5">
                      <MapPin className="w-3.5 h-3.5 text-urb-primary" />
                      {product.cidade_evento || "Macapá - AP"}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <Calendar className="w-3.5 h-3.5 text-urb-primary" />
                      {formatDateBR(
                        product.data_evento || product.inicio_inscricao
                      ) !== "-"
                        ? formatDateBR(
                            product.data_evento || product.inicio_inscricao
                          )
                        : "10 de junho de 2026"}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <Navigation className="w-3.5 h-3.5 text-urb-primary" />
                      {product.distancia || "5K"}
                    </span>
                  </div>

                  {/* Price */}
                  <div className="flex flex-col">
                    <span className="text-[10px] text-slate-500 uppercase tracking-wider font-semibold">
                      {isLotePendente ? "Valor individual / Total do Pedido" : "Valor da inscrição"}
                    </span>
                    <div className="flex items-baseline gap-2">
                      <span className="text-lg font-black text-white">
                        R${" "}
                        {product.valor_pagamento || product.valor_inscricao
                          ? Number(
                              product.valor_pagamento || product.valor_inscricao
                            ).toLocaleString("pt-BR", {
                              minimumFractionDigits: 2,
                            })
                          : "0,00"}
                      </span>
                      {isLotePendente && (
                        <span className="text-xs text-amber-400 font-bold">
                          (Total do lote: R$ {valorTotalLote.toLocaleString("pt-BR", { minimumFractionDigits: 2 })})
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Right Column: Actions */}
                <div className="w-full lg:w-56 flex flex-col justify-between items-stretch gap-3 border-t lg:border-t-0 lg:border-l border-urb-border pt-4 lg:pt-0 lg:pl-6">
                  {isPending ? (
                    <div className="flex items-start gap-2 p-2.5 rounded-xl bg-amber-500/10 border border-amber-500/20 text-xs text-amber-300">
                      <Clock className="w-4 h-4 shrink-0 mt-0.5" />
                      <span className="leading-tight">
                        {isLotePendente
                          ? `Finalize o pagamento de ${grupoPendente.length} inscrições do pedido.`
                          : "Finalize o pagamento para garantir sua vaga."}
                      </span>
                    </div>
                  ) : isFinished ? (
                    <div className="flex items-start gap-2 p-2.5 rounded-xl bg-slate-800/40 border border-slate-700 text-xs text-slate-400">
                      <Flag className="w-4 h-4 shrink-0 mt-0.5" />
                      <span className="leading-tight">Prova encerrada!</span>
                    </div>
                  ) : (
                    <div className="flex items-start gap-2 p-2.5 rounded-xl bg-urb-primary/10 border border-urb-primary/30 text-xs text-urb-primary">
                      <CheckCircle2 className="w-4 h-4 shrink-0 mt-0.5" />
                      <span className="leading-tight">
                        Vaga confirmada!
                      </span>
                    </div>
                  )}

                  <div className="flex flex-col gap-2 mt-auto">
                    {isPending ? (
                      <Button
                        variant="primary"
                        size="md"
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedProduct({
                            ...product,
                            valor_total_grupo: valorTotalLote,
                            inscricoes_grupo: isLotePendente ? grupoPendente : [product]
                          });
                          setPaymentError(null);
                          setVisibleDialogPagamento(true);
                        }}
                        className="w-full font-bold text-xs uppercase flex items-center justify-center gap-1.5"
                      >
                        {isLotePendente ? "Pagar Pedido" : "Pagar agora"}
                        <ChevronRight className="w-4 h-4 ml-1" />
                      </Button>
                    ) : (
                      <Button
                        variant="primary"
                        size="md"
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedProduct(product);
                          handleMetricaCorredor(
                            product.id_corrida || product.id
                          );
                        }}
                        className="w-full font-bold text-xs uppercase flex items-center justify-center gap-1.5"
                      >
                        <BarChart2 className="w-4 h-4" />
                        Métricas
                      </Button>
                    )}

                    <Button
                      variant="secondary"
                      size="md"
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedProduct(product);
                        setVisible(true);
                      }}
                      className="w-full font-semibold text-xs flex items-center justify-center gap-1.5"
                    >
                      <Eye className="w-4 h-4" />
                      Visualizar
                    </Button>
                  </div>
                </div>
              </div>
            );
          })
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex items-center justify-center gap-2 mt-4">
            <button
              type="button"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
              className="px-3 py-1.5 rounded-lg border border-slate-800 bg-slate-900 text-xs text-slate-300 disabled:opacity-40 cursor-pointer"
            >
              Anterior
            </button>
            <span className="text-xs text-slate-400">
              Página {currentPage} de {totalPages}
            </span>
            <button
              type="button"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
              className="px-3 py-1.5 rounded-lg border border-slate-800 bg-slate-900 text-xs text-slate-300 disabled:opacity-40 cursor-pointer"
            >
              Próxima
            </button>
          </div>
        )}
      </div>

      {/* Inscription Details Modal */}
      <Modal
        isOpen={visible}
        onClose={() => setVisible(false)}
        title="Detalhes da Inscrição"
        maxWidth="max-w-3xl"
      >
        <DetailInscricao detail={selectedProduct} />
      </Modal>

      {/* Race Metrics Modal */}
      <Modal
        isOpen={visibleDialogMetrica}
        onClose={() => setVisibleDialogMetrica(false)}
        title="Métricas da Prova"
        maxWidth="max-w-2xl"
      >
        {metricaLoading ? (
          <p className="text-white p-4">Carregando métricas...</p>
        ) : metricaContent ? (
          metricaContent
        ) : (
          <NovaMetricaCorredor
            idCorrida={
              selectedProduct
                ? selectedProduct.id_corrida || selectedProduct.id
                : null
            }
            onSuccess={handleMetricaSuccess}
            onError={handleMetricaError}
          />
        )}
      </Modal>

      {/* Payment Modal */}
      <Modal
        isOpen={visibleDialogPagamento}
        onClose={() => {
          setVisibleDialogPagamento(false);
          setPaymentError(null);
        }}
        title="Pagamento da Inscrição"
        maxWidth="max-w-2xl"
      >
        {paymentError && (
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 p-3.5 mb-4 rounded-xl bg-red-950/40 border border-red-800/40 text-xs font-semibold text-red-200">
            <div className="flex items-center gap-2">
              <AlertTriangle className="w-5 h-5 text-red-400 shrink-0" />
              <span>{paymentError}</span>
            </div>
            <Link
              to="/novas-corridas"
              className="font-bold underline text-urb-primary flex items-center gap-1 shrink-0"
              onClick={() => setVisibleDialogPagamento(false)}
            >
              <span>Fazer nova inscrição</span>
              <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </div>
        )}
        {selectedProduct && (
          <CheckoutPage
            inscricaoId={selectedProduct.id_grupo_pagamento || selectedProduct.id_requisicao || selectedProduct.id}
            valorTotal={
              selectedProduct.valor_total_grupo || selectedProduct.valor_pagamento || selectedProduct.valor_inscricao
            }
            nomeCorrida={selectedProduct.nome_corrida}
            inscricoesLote={selectedProduct.inscricoes_grupo}
            onSuccess={() => {
              setPaymentError(null);
              fetchData(0);
              fetchData(2);
            }}
            onFinished={() => {
              setVisibleDialogPagamento(false);
              setPaymentError(null);
              fetchData(0);
              fetchData(2);
            }}
            onError={handlePaymentError}
          />
        )}
      </Modal>

      {/* Strava Import Modal */}
      <StravaImportModal
        isOpen={showStravaModal}
        onClose={() => setShowStravaModal(false)}
        idCorrida={
          selectedProduct
            ? selectedProduct.id_corrida || selectedProduct.id
            : null
        }
        idCategoriaCorrida={selectedProduct?.id_categoria_corrida || null}
        onSuccess={async (res) => {
          setShowStravaModal(false);
          await handleMetricaSuccess();
        }}
        onError={handleMetricaError}
      />
    </div>
  );
}

export default MinhasCorridasComponent;
